module.exports = __webpack_public_path__ + "img/yj_send_bless_float.3e3503b3.gif";